import type { FC } from "react";
import { IconProps } from "./types";

export const NavPersonal: FC<IconProps> = ({ size = "1em", ...props }) => (
  <svg width={size} height={size} fill="none" viewBox="0 0 36 36" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.97 29.16a6 6 0 0 1 5.53-3.66h9a6 6 0 0 1 5.53 3.66M24 14.25a6 6 0 1 1-12 0 6 6 0 0 1 12 0ZM33 18a15 15 0 1 1-30 0 15 15 0 0 1 30 0Z"
    />
  </svg>
);
